var React = require('react');

function Circles (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.568894","cx":"67","cy":"43","r":"24","fill":"#77268B","fillOpacity":"0.15","key":0}),React.createElement("circle",{"opacity":"0.568894","cx":"33.5","cy":"33.5","r":"33.5","fill":"#77268B","fillOpacity":"0.24","key":1})]);
}

Circles.defaultProps = {"width":"91","height":"67","viewBox":"0 0 91 67","fill":"none"};

module.exports = Circles;

Circles.default = Circles;
